import React, { FC } from 'react';
import ChatSideBar from 'components/chatSideBar/ChatSideBar';
import ChatContent from 'components/chatContent/ChatContent';
import MessageThread from 'components/chatContent/messageThread/MessageThread';
import ChatInfo from 'components/chatContent/chatInfo/ChatInfo';
import Styles from 'views/chatScreen/ChatScreen.module.scss';
import { useChatRoomPanel } from './useChatRoomPanel';

interface ChatRoomPanelProps {
  fullPage?: boolean;
  onCreateRoom?: () => void;
  /** Phone drawer app links — use when global header chrome is hidden. */
  showAppNav?: boolean;
}

const ChatRoomPanel: FC<ChatRoomPanelProps> = ({
  fullPage = false,
  onCreateRoom,
  showAppNav = false,
}) => {
  const {
    showReplies,
    setShowReplies,
    activateRoom,
    setActiveRoom,
    chatInfo,
    setChatInfo,
    showThreads,
    sidebarOpen,
    isMobile,
    selected,
    setSelected,
    isJoined,
    chat,
    allRooms,
    hasMore,
    isLoading,
    isLoadingMore,
    loadOlderMessages,
    isInitialized,
    handleThreads,
    callBack,
    handleSidebarToggle,
    handleSidebarClose,
  } = useChatRoomPanel();

  return (
    <section
      className={`${Styles.bodyContent} ${fullPage ? Styles.bodyContentFullPage : ''}`}
    >
      <div
        className={`${Styles.startScreenWrapper} ${sidebarOpen ? Styles.sidebarOpen : ''} ${
          chatInfo ? Styles.chatInfoOpen : ''
        } ${showReplies && isMobile ? Styles.messageThreadOpen : ''}`}
      >
        <div className={Styles.sidebarOverlay} onClick={handleSidebarClose} />
        {chatInfo && <div className={Styles.chatInfoOverlay} onClick={() => setChatInfo(false)} />}
        {showReplies && isMobile && (
          <div className={Styles.messageThreadOverlay} onClick={() => setShowReplies(false)} />
        )}
        <ChatSideBar
          selected={selected}
          conversations={allRooms}
          setSelected={setSelected}
          activateRoom={activateRoom}
          setActiveRoom={setActiveRoom}
          callBack={callBack}
          sidebarOpen={sidebarOpen}
          onClose={handleSidebarClose}
          onRoomChange={() => setChatInfo(false)}
          onCreateRoom={onCreateRoom}
          showAppNav={showAppNav}
          fullPage={fullPage}
        />
        <section
          className={`${Styles.chatSection} ${!isJoined && Styles.notJoinedWrapper} ${
            showReplies || chatInfo ? Styles.threadSection : ''
          }`}
        >
          <ChatContent
            key={`chat-${selected?.pk || 'no-room'}`}
            fullPage={fullPage}
            replyItems={(e: any) => handleThreads(e)}
            viewReplies={() => {
              setShowReplies(true);
              setChatInfo(false);
            }}
            chatInfo={() => {
              setChatInfo(!chatInfo);
              setShowReplies(false);
            }}
            chats={chat}
            selected={selected}
            actions={showReplies}
            activateRoom={activateRoom}
            hasMore={hasMore}
            isLoading={isLoading}
            isLoadingMore={isLoadingMore}
            loadOlderMessages={loadOlderMessages}
            isInitialized={isInitialized}
            isJoined={isJoined}
            onMenuClick={handleSidebarToggle}
            allRooms={allRooms}
          />
        </section>
        {chatInfo && (
          <ChatInfo
            info={selected}
            setSelected={setSelected}
            allRooms={allRooms}
            isJoined={isJoined}
            onClose={() => setChatInfo(false)}
            isDrawerOpen={chatInfo}
          />
        )}
        {showReplies && (
          <MessageThread
            actions={showReplies}
            selected={selected}
            item={showThreads}
            hideReplies={(e: any) => setShowReplies(e)}
            isDrawerOpen={showReplies && isMobile}
          />
        )}
      </div>
    </section>
  );
};

export default ChatRoomPanel;
